import React from 'react';

const Footer = () => {

    const style = {
        "padding": '30px',
        "height": '100px',
        "text-align": 'center',
        "font-size": '2rem',
        "background-color": 'black'
    }

    return (
        <footer style={style}> Road to Jazz Freak </footer>
    )
}

export default Footer



// WEBPACK FOOTER //
// ./src/App/Footer/Footer.js